import React, { useState, useEffect, Component } from "react";
import styled from "styled-components";

const UpArrow = require("../../../../assets/imgs/upArrow.png");
const DownArrow = require("../../../../assets/imgs/downArrow.png");

const CreditRewardsItemDetails = (props) => {
  const { creditRewardsItemDetails} = props;

  const handleProceed = () => {
    let inputString = "Proceed" + "<split>" + "Proceed";
    window["autosubmit"](inputString);
     
  };

  const showItemsDetail = () => {
 
    return (
      <div>
        {creditRewardsItemDetails.map((item, i) => {
          return (
            <StatementDetail key={i}>
              <SummaryAccordion
                 StockItemTitle={item.stock_item_title} 
                // Quantity={item.quantity}
                // Price={item.price}
                // StockItemId={item.stock_item_Id}
                // Points={item.points}
                Category={item.Category}
                OrderId={item.Order_Id}
                DateOfRedemption={item.Date_of_Redemption}
                PointsRedeemed={item.Points_Redeemed}
                AmountPaid={item.Amount_Paid}
                noItems={creditRewardsItemDetails.length}
              />
            </StatementDetail>
          );
        })}
      </div>
    );
  };
  return (
    <React.Fragment>
      {showItemsDetail()}

      <div className="action-elem" 
            style={{marginTop:"16px"}} onClick={() => handleProceed()}>
        Proceed
      </div>
     
    </React.Fragment>
  );
};

const StatementDetail = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
`;

//Accordion Component
class SummaryAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundImage: DownArrow,
      isClicked: false,
      showSummaryDetail: this.props.noItems==1?true:false,
    };
  }

  handleClickState = () => {
    
    if (this.state.isClicked == false) {
      this.setState({
        isClicked: true,
        backgroundImage: UpArrow,
        showSummaryDetail: true,
      });
    } else {
      this.setState({
        isClicked: false,
        backgroundImage: DownArrow,
        showSummaryDetail: false,
      });
    }
  };

  render() {
    //console.log(this.props.oneItem)
    const Summary_mainBlock = styled.div`
      position: relative;
      display: flex;
      flex-direction: column;
      margin: 0px 12px;
      border: 1px solid #fcfcfc;
      border-radius: 4px;
      box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.2);
      background: #fcfcfc;
    `;
    const Summary_titleBlock = styled.div`
      cursor: pointer;

      & .transactionTitle {
        font-size: 13.5px;
        font-weight: 500;
        padding: 12px;
        width: 90%;
       
      }
      & .arrowBlock {
        position: absolute;
        top: 16px;
        right: 0px;
        height: 30px;
        width: 30px;
        background: url(${this.state.backgroundImage});
        background-repeat: no-repeat;
      }
    `;
    const DashDivider = styled.div`
      border-bottom: 1px dashed rgba(102, 102, 102, 0.2);
    `;
    const PlanRow = styled.div`
      padding: 10px 12px;
    `;
    const PlanLabel = styled.div`
      display: inline-block;
      vertical-align: middle;
      width: 60%;
      text-align: left;
      margin: 0px;
      font-size: 13.5px;
    `;
    const PlanValue = styled.div`
      display: inline-block;
      vertical-align: middle;
      width: 40%;
      text-align: right;
      font-weight: 600;
      font-size: 13.5px;
      color: #003e8d;
    `;
    
    //
    return (
      <Summary_mainBlock>
        <Summary_titleBlock onClick={() => this.handleClickState()}>
          <div className="transactionTitle">
            {this.props.StockItemTitle}
          </div>
          <div className="arrowBlock" />
        </Summary_titleBlock>

        {this.state.showSummaryDetail ? (
          <div>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Category</PlanLabel>
              <PlanValue>{this.props.Category}</PlanValue>
            </PlanRow>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Order Id</PlanLabel>
              <PlanValue>{this.props.OrderId}</PlanValue>
            </PlanRow>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Date of Redemption</PlanLabel>
              <PlanValue>{this.props.DateOfRedemption}</PlanValue>
            </PlanRow>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Points Redeemed</PlanLabel>
              <PlanValue>{this.props.PointsRedeemed}</PlanValue>
            </PlanRow>
            <DashDivider />
            <PlanRow>
              <PlanLabel>Amount Paid</PlanLabel>
              <PlanValue>₹ {this.props.AmountPaid}</PlanValue>
            </PlanRow>
            
          </div>
        ) : null}
      </Summary_mainBlock>
    );
  }
}
export default CreditRewardsItemDetails;